module.exports = __webpack_public_path__ + "img/Insulation-Training-02.2d8e057e.jpg";